/* eslint-disable @typescript-eslint/no-unused-vars */

import { MEDIA_TYPE_MAP } from './constant'
import { getFormateFileSize } from './index'
import { useTime } from '~/hooks/useTime'
const PlatformLogo = getFeUrl('/youyan-platform/png/platform-logo.png')

export const transformList = (list: any[]): any[] => {
  const { $t } = useNuxtApp()
  const { timeFormatText } = useTime()
  return list.map((item: any) => {
    const {
      cover_url: cover,
      name: title,
      name_for_show,
      avatar_url,
      username: name,
      user_logo_url: avatar,
      tag_name,
      preview_video,
      create_time,
      update_time,
      source_update_time,
      source_username,
      media_size,
      is_star_personal = false,
      brand_guidelines: isBrand,
      tags: Tag,
      last_generate_record_data: lastGenerate,
      youyan_config_scenes,
      video_url,
      url: baseUrl,
      cover_image_url,
      preview_video_list,
      preview_videos,
      config,
      source_is_delete,
      finish_time,
      export_time = '',
      is_template = 0,
      xihe_task_progress_info = {},
      description = '',
      source_user_logo_url,
      copyright_limited: limited = false,
      task_source_project_is_delete: project_is_delete,
      ...rest
    } = item
    let tags = []
    let personTags = []
    let configScenes = {}
    let url: string[] = []
    // let
    // const url = preview_video_list.length ? preview_video_list:[];
    if (item?.media_type) {
      tags.push({ label: MEDIA_TYPE_MAP()[item.media_type] })
    }

    // 打开并定位至相关
    if (item?.last_generate_record_data?.segment_log_id) {
      tags.push({
        label: $t('nei-rong'),
        key: 'content',
      })
    }

    if (item?.last_generate_record_data?.camera_log_id) {
      tags.push({
        label: $t('jing-tou'),
        key: 'camera',
      })
    }

    if (item?.last_generate_record_data?.video_packaging_log_id) {
      tags.push({
        label: $t('bao-zhuang'),
        key: 'video',
      })
    }

    switch (item.media_type) {
      case 1:
        url.push(cover)
        break
      case 3:
        if (preview_video && typeof preview_video === 'string') {
          url.push(...JSON.parse(preview_video))
        }

        break
      // case 11 || 12:
      //   url.push(item?.file_url);
      //   break;
      default:
        break
    }

    if (preview_video_list?.length || preview_videos?.length) {
      url = url.concat(preview_video_list || preview_videos)
    }

    if (lastGenerate?.video_url && is_template === 0) {
      url.push(lastGenerate.video_url)
    }

    if (item?.file_url) {
      url.push(item?.file_url)
    }

    if (video_url) {
      url = [video_url]
    }

    if (item?.is_template === 1 && preview_video) {
      url = Array.isArray(preview_video) ? preview_video : [preview_video]
    }

    // if (item?.resource_type && [RESOURCE_TYPE.MUSIC, RESOURCE_TYPE.SOUND_EFFECT].includes(item.resource_type)) {
    //   url = [item.url || config.url || item.file_url];
    // }
    // 音色数据结构变更-不返回youyan_config_scenes
    if (item?.resource_type && RESOURCE_TYPE.TIMBRE === item.resource_type) {
      // if (youyan_config_scenes?.length) {
      //   configScenes = youyan_config_scenes
      // } else {
      configScenes = {
        ...config,
        url: config.audio_url || config.url,
        id: item.id,
        name: config.gender,
      }
      // }
      tags = tags.concat(Tag)
    }

    if (RESOURCE_TYPE.PERSON === item.resource_type && item.tags?.length) {
      personTags = item.tags.map((item: string) => ({
        label: item,
        key: item,
      }))
    }

    let vertical = false // 是否是竖屏
    if (
      (item.resolution && item?.resolution === '1080x1920') ||
      (item?.project_resolution && item.project_resolution === '1080x1920')
    ) {
      vertical = true
    }

    // 场景/人物 预览
    if (
      item.resource_type === RESOURCE_TYPE.STUDIO ||
      item.resource_type === RESOURCE_TYPE.PERSON
    ) {
      url = item.preview_video_list || item.preview_videos
    }

    // 获取音频文件，兼容空间后端接口字段不统一
    if (
      item.resource_type &&
      [
        RESOURCE_TYPE.MUSIC,
        RESOURCE_TYPE.SOUND_EFFECT,
        RESOURCE_TYPE.HEAD,
        RESOURCE_TYPE.END,
      ].includes(item.resource_type)
    ) {
      url = [item.url ?? item.file_url ?? item?.music_url]
    }

    let size = ''
    if (media_size) {
      size = getFormateFileSize(media_size)
    }

    if (config?.size_format || config?.size) {
      size = config?.size_format
        ? config?.size_format
        : config?.size
          ? getFormateFileSize(config?.size)
          : ''
    }

    return {
      cover: transformImage(cover ?? cover_image_url, { height: 300 }),
      title,
      name: name_for_show || source_username || name,
      avatar: transformImage(avatar_url || avatar),
      url,
      video_url,
      size,
      edit: false,
      like: is_star_personal,
      tags,
      isBrand,
      isDelete: source_is_delete,
      project_is_delete,
      lastGenerate,
      vertical,
      configScenes,
      preview_video_list: preview_video_list || preview_videos,
      // preview_videos,
      description,
      personTags,
      source_user_logo_url: transformImage(
        avatar_url || source_user_logo_url || PlatformLogo
      ),
      // description: item?.media_size ? getFormateFileSize(item?.media_size) : '',
      ...xihe_task_progress_info,
      ...rest,
      time: update_time ? timeFormatText(new Date(update_time).getTime()) : '',
      create_time: create_time
        ? timeFormatText(new Date(create_time).getTime())
        : '',
      finish_time: finish_time
        ? timeFormatText(new Date(finish_time).getTime())
        : '',
      export_time: export_time
        ? timeFormatText(new Date(export_time).getTime())
        : '',
      source_time: source_update_time
        ? timeFormatText(new Date(source_update_time).getTime())
        : '',
      update_time,
      limited,
    }
  })
}
export function htmlToPlainText(html: string) {
  // Create a temporary DOM element to hold the HTML
  const tempDivElement = document.createElement('div')

  // Set the HTML content
  tempDivElement.innerHTML = html

  // Retrieve and return the text content
  return tempDivElement.textContent || tempDivElement.innerText || ''
}

export function toUrlFriendly(text: string) {
  return text
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-\u4E00-\u9FFF]/g, '')
}
